<script lang="ts" setup>
import {computed} from 'vue';
import type {ComponentContent} from '@/ts/types/dto/interventions-dto';
import RecommendationCardFeatured from '@/vue/molecules/recco/recommendation-cards/recommendation-card-featured.vue';
import {useViewedContentStore} from '@/ts/store/viewed-content-store';
import {withConsumed} from '@/ts/utils/consumed-overlay';

const props = withDefaults(defineProps<{
  blockContent: ComponentContent;
  // i18n key forwarded to the card as its back-navigation label.
  pageTitle?: string;
  // Forwarded to the card so the "Recommended" marker only shows where the
  // featured item is recommendation-driven (the Explore hero).
  markRecommended?: boolean;
  // Forwarded to the card — see its own prop.
  eyebrowKey?: string;
}>(), {
  pageTitle: 'recco_explore',
  markRecommended: false,
});

const viewedContent = useViewedContentStore();

// Deliberately not named `blockContent`: that would shadow the prop, and the template would
// silently fall back to the raw prop if anyone switched to destructured defineProps.
const overlaidContent = computed<ComponentContent>(() =>
  withConsumed(props.blockContent, viewedContent.hasViewed(props.blockContent.id)));

</script>

<template>
  <div class="recco-featured-recommendation">
    <recommendation-card-featured
      :block-content="overlaidContent"
      :page-title="props.pageTitle"
      :mark-recommended="props.markRecommended"
      :eyebrow-key="props.eyebrowKey"
      class="featured-card"
    />
  </div>
</template>

<style lang="scss" scoped>
.recco-featured-recommendation {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
  @include column-width(12);
  @include min-featured-card-height;
  margin-bottom: var(--Spacing-spacing-4);
}
</style>
